import { Message, Chat, ChatUser, Case } from "src/api/classes";
import { cleanDatabase } from "src/store/db";
import { Permissions } from "src/api/constants";
export const DEFAULT_AVATAR = "/assets/img/avatar6.png";
export function isAuthenticated(): boolean {
  let token = window.localStorage.getItem("token");
  const hasToken = !!token;
  if (hasToken) {
    return true;
  }
  return false;
}

export function hasPermissionOf(permission: string) {
  // TODO: implement jwt
  const role = userGroups();
  const guest_roles = [
    Permissions.READ_CASES,
    Permissions.READ_USERS,
    Permissions.READ_TAGS,
    Permissions.READ_CATEGORIES,
    Permissions.GET_URL_DETAIL
  ];
  if (role === "4") {
    return guest_roles.indexOf(permission) > -1;
  } else {
    return true;
  }
}

export function userGroups(): string {
  let role = window.localStorage.getItem("role");
  return role;
}
export function getUserName(): string {
  let role = window.localStorage.getItem("dubito/accountName");
  return role;
}
export function getUserPicture(): string {
  let role = window.localStorage.getItem("dubito/accountPicture");
  if (!role || role === null || role === "null") {
    return DEFAULT_AVATAR;
  }
  return role;
}
export function getUserID(): string {
  let role = window.localStorage.getItem("id");
  return role;
}
export function logout() {
  window.localStorage.clear();
  cleanDatabase();
  window.location.href = "/login";
}
export function getMessages(): Message[] {
  let role = JSON.parse(
    window.localStorage.getItem("dubito/messages") || "[]"
  ) as Message[];
  if (role.length === 0) {
    return undefined;
  }
  return role;
}
export function getCases(): Case[] {
  let role = JSON.parse(
    window.localStorage.getItem("dubito/cases") || "[]"
  ) as Case[];
  if (role.length === 0) {
    return undefined;
  }
  return role;
}
export function saveMessages(messages: Message[]) {
  let role = window.localStorage.setItem(
    "dubito/messages",
    JSON.stringify(messages)
  );
  return role;
}
export function getChats(): Chat[] {
  let role = JSON.parse(
    window.localStorage.getItem("dubito/chats") || "[]"
  ) as Chat[];
  if (role.length === 0) {
    return undefined;
  }
  return role;
}
export function getChatUsers(): ChatUser[] {
  let role = JSON.parse(
    window.localStorage.getItem("dubito/chatUsers") || "[]"
  ) as ChatUser[];
  if (role.length === 0) {
    return [];
  }
  return role;
}
export function saveChatUsers(chats: ChatUser[]) {
  let role = window.localStorage.setItem(
    "dubito/chatUsers",
    JSON.stringify(chats.slice(Math.max(0, chats.length - 1000), chats.length))
  );
  return role;
}
export function saveChats(chats: Chat[]) {
  let role = window.localStorage.setItem("dubito/chats", JSON.stringify(chats));
  return role;
}
export function saveCases(cases: Case[]) {
  let role = window.localStorage.setItem("dubito/cases", JSON.stringify(cases));
  return role;
}



// WEBPACK FOOTER //
// ./src/auth/auth.ts